<template>
  <div class="anonymous">
    <div style="width:100%">
      <h3>举报人信息 (注意: 标有 <span class="must">*</span> 的必须填写)</h3>
      <el-form ref="formdata" :model="formdata" label-width="80px" :rules="rulesFrom">
        <div class="row">
          <el-form-item label="举报人姓名" prop="informantName">
            <el-input v-model="formdata.informantName" maxlength="10"></el-input>
          </el-form-item>
          <el-form-item label="单位名称" prop="informantUnit">
            <el-input v-model="formdata.informantUnit" maxlength="32"></el-input>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item label="证件类型" prop="informantDocumentType">
            <el-select
                v-model="formdata.informantDocumentType"
                placeholder="请选择"
            >
              <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="证件号" prop="informantIdNumber">
            <el-input v-model="formdata.informantIdNumber" maxlength="18" show-word-limit></el-input>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item label="手机号" type="" prop="informantPhone">
            <el-input v-model="formdata.informantPhone" maxlength="11" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="邮箱" prop="informantEmail">
            <template>
              <el-input v-model="formdata.informantEmail"></el-input>
            </template>
          </el-form-item>
        </div>
        <div class="row" style="height:42px">
          <el-form-item label="有效证件附件" style="width: 250px">
            <el-upload
                class="upload"
                :action="effectiveUrl"
                :file-list="certificateFileList"
                show-file-list
                :on-change="handleExcel"
                accept="image/jpeg, image/png, .bmp, image/jpeg, image/tiff"
                :auto-upload="true"
                :before-remove="beforeremove"
                :on-preview="onload"
                :headers="{
                //请求头
                'OTP': otp}"
                :on-success="effectivesuccess"
            >
              <el-button icon="el-icon-folder-add" type="primary"
              >上传文件
              </el-button
              >
            </el-upload>
          </el-form-item>
        </div>
        <div class="row" v-if="twoisshow">
            <span style="font-size: 0.9em;">
                <p class="tips">
                    <span>
                        <img src="../../../assets/img/themes/tips.png" alt="">
                    请注意:
                    </span>
                    <img src="../../../assets/img/themes/close-black.png" alt="" class="back"
                         @click="twoisshow = false">
                    </p>
                 严禁冒用他人姓名和身份举报！
              冒名举报将承担法律责任，温馨提示：
              请上传举报人有效身份证件图片信息，每个文件不大于2M。附件仅限于文件名后缀为.jpg、.png、.bmp、.peg、.tiff的文件，禁止exe、bat等格式文件上传；手机号和邮箱应为本人常用联系方式。</span>
        </div>
        <h3>举报信息 (注意: 标有 <span class="must">*</span> 的必须填写)</h3>
        <div class="row">
          <el-form-item label="问题类型" prop="questionType" >
            <el-select v-model="formdata.questionType" placeholder="请选择问题类型" style="width: 260px; margin-left: 0;" @change="questionTypeChange">
              <el-option key="" label="--请选择问题类型--" value=""></el-option>
              <el-option v-for="item in questionTypeOptions" :key="item.typeCode" :label="item.typeValue" :value="item.typeCode">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item label="违规主体" prop="unreliableType">
            <el-select v-model="formdata.unreliableType" placeholder="请选择违规主体" style="width: 260px; margin-left: 0;" @change="unreliableTypeChange">
              <el-option key="" label="--请选择违规主体--" value=""></el-option>
              <el-option v-for="item in unreliableTypeOptions" :key="item.typeCode" :label="item.typeValue" :value="item.typeCode">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item label="违规行为" prop="unreliableActType" style="width: 100%; margin-bottom: 2px">
            <el-select v-model="formdata.unreliableActType" placeholder="请选择违规行为" style="width: 100%; margin-left: 0;" multiple collapse-tags>
              <el-option v-for="item in unreliableActTypeOptions" :key="item.typeCode" :label="item.typeValue" :value="item.typeCode">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="row" style="margin-bottom: 20px">
          <!-- 单独显示选中项的区域 -->
          <div class="selected-tags" style="width: 100%;" v-if="formdata.unreliableActType && formdata.unreliableActType.length > 0">
            <!--  <div class="tag-label">已选择违规行为：</div>-->
            <el-tag v-for="(item, index) in getSelectedLabels(formdata.unreliableActType)"
                    :key="index" closable  @close="removeTag(index)" style="margin: 2px 2px 2px 80px;">
              {{ item }}
            </el-tag>
          </div>
        </div>
        <div class="row" v-show="false">
          <el-form-item label="举报对象" prop="reportSubject" style="display:flex;align-items:center">
            <el-radio-group v-model="formdata.reportSubject" style="width: 260px;margin-left:0" @change="subjectChangeForm">
              <el-radio v-model="formdata.reportSubject" :label="'1'">个人</el-radio>
              <el-radio v-model="formdata.reportSubject" :label="'2'">单位</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <div class="individual" v-if="formdata.reportSubject == '1' || formdata.reportSubject == undefined">
          <div class="row">
            <el-form-item label="被举报人姓名" prop="unreliableName">
              <el-input v-model="formdata.unreliableName" maxlength="10"></el-input>
            </el-form-item>
            <el-form-item label="所在单位/机构名称" prop="unitName">
              <el-input v-model="formdata.unitName" maxlength="32"></el-input>
            </el-form-item>
          </div>
          <div class="row">
            <el-form-item label="证件号" prop="idNo">
              <el-input v-model="formdata.idNo" maxlength="18"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="unreliablePhoneNumber">
              <el-input v-model="formdata.unreliablePhoneNumber" maxlength="11"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="individual" v-if="formdata.reportSubject == 2">
          <div class="row">
            <el-form-item label="单位/机构名称" prop="unreliableUnitName">
              <el-input v-model="formdata.unreliableUnitName" maxlength="32"></el-input>
            </el-form-item>
            <el-form-item label="统一社会信用代码" prop="uscc">
              <el-input v-model="formdata.uscc" maxlength="18"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="row">
          <el-form-item label="举报内容" style="width: 100%" prop="reportItem">
            <el-input
                type="textarea"
                v-model="formdata.reportItem"
                style="width: 100%"
                placeholder="请填写举报内容，不多于5000字"
                maxlength="5000"
            ></el-input>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item label="个人诉求" style="width: 100%" prop="informantAppeal">
            <el-input type="textarea" v-model="formdata.informantAppeal" maxlength="2000"
                      placeholder="请填写个人诉求，不多于2000字" style="width: 100%"></el-input>
          </el-form-item>
        </div>
        <div class="row" style="height:42px">
          <el-form-item label="佐证材料" style="width: 250px" prop="reportFileIds">
            <el-upload
                class="upload"
                :action="effectiveUrl"
                :multiple="true"
                :file-list="reportFileList"
                :on-change="handleExcel"
                show-file-list
                accept='image/jpeg, image/png, bmp, image/jpeg, image/tiff,application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,  application/vnd.ms-excel, application/pdf'
                :auto-upload="true"
                :before-remove="evidenbeforeremove"
                :before-upload="beforeUploadFile"
                :headers="{
                //请求头
                'OTP': otp}"
                :on-success="evidencesuccess"
            >
              <el-button icon="el-icon-folder-add" type="primary"
              >上传文件
              </el-button
              >
            </el-upload>
          </el-form-item>
        </div>
        <div class="row" v-if="isshow">
            <span style="font-size: 0.9em;">
                <p class="tips">
                    <span>
                        <img src="../../../assets/img/themes/tips.png" alt="">
                    请注意:
                    </span>
                    <img src="../../../assets/img/themes/close-black.png" alt="" class="back" @click="isshow = false">
                </p>
              每个文件不大于20M。支持Word、PowerPoint、Excel可编辑文档、PDF、图片，附件仅限于文件名后缀为.jpg、 .png、 .bmp、 .jpeg、 .tiff、 .doc、 .docx、 .ppt、 .pptx、 .xls、 .xlsx、 .pdf的文件，禁止exe、 bat等格式文件上传！超过20M的附件，请通过固态载体(U盘或硬盘) 邮寄给我们。</span>
        </div>

        <div class="row jc-c">
          <el-button @click="back">取消</el-button>
          <el-button type="info" :loading="loading1" @click="staging">暂存</el-button>
          <el-button type="primary" :loading="loading" @click="submit">提交</el-button>
        </div>
      </el-form>
    </div>

  </div>
</template>

<script>
import personService from "@/api/report/report.js";
import baseURL from "@/utils/baseUrl1";

export default {
  data () {
    const isCnNewID = (rule, value, callback) => {
      var arrExp = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];//加权因子
      var arrValid = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2];//校验码
      if (/^\d{17}\d|x$/i.test(value)) {
        var sum = 0, idx;
        for (var i = 0; i < value.length - 1; i++) {
          // 对前17位数字与权值乘积求和
          sum += parseInt(value.substr(i, 1), 10) * arrExp[i];
        }
        // 计算模（固定算法）
        idx = sum % 11;
        // 检验第18为是否与校验码相等
        if (arrValid[idx] == value.substr(17, 1).toUpperCase()) {
          callback()
        } else {
          callback("身份证格式有误")
        }
      } else {
        callback()
      }
    }
    const checkphone = (rule, value, callback) => {
      if (typeof (value) != "undefined") {
        if (!(/^1[345789]\d{9}$/.test(value))) {  //手机号正则校验
          if (!value) { //若手机号为空///
            callback()
          } else { //手机号非空的报错信息
            callback("手机号码格式错误：" + value)
          }
        } else { //手机号正确则无错误信息
          this.s_telephone1 = "";
          callback()
        }
      } else {
        callback()
      }
    }
    return {
      s_telephone1: "",
      isshow: true,
      twoisshow: true,
      otp: '',
      effectiveUrl: baseURL.person + '/file-deal/report/file-import',
      fileList: [],
      reportFileList: [], //佐证材料
      reportFileIds: [], //佐证材料
      certificateFileList: [],
      //   上传格式
      allowHook: {
        video: ["mp4", "ogv", "ogg", "webm"],
        audio: ["wav", "mp3", "ogg", "acc", "webm", "amr"],
        file: ["doc", "docx", "xlsx", "xls", "pdf"],
        excel: ["xlsx", "xls"],
        img: ["jpg", "jpeg", "png", "gif"],
      },
      formdata: {
        certificateAttachment: "", //举报人证件附件
        certificateAttachmentIds: [], //举报人证件附件ID
        reportType: 2, //举报类型 1-实名举报 2-匿名举报
        reportFileIds: [], //佐证材料
        reportSubject: 1,
        questionType: '',
        unreliableType: '',
        unreliableActType: []
      },
      updateFormdata: {
        certificateAttachment: "", //举报人证件附件
        certificateAttachmentIds: [], //举报人证件附件ID
        reportType: 2, //举报类型 1-实名举报 2-匿名举报
        reportFileIds: [], //佐证材料
        reportSubject: 1,
        questionType: '',
        unreliableType: '',
        unreliableActType: []
      },
      options: [
        {
          value: "1",
          label: "二代身份证",
        },
      ],
      // 问题类型
      questionTypeOptions: [],
      // 主体类型
      unreliableTypeOptions: [],
      // 失信行为
      unreliableActTypeOptions: [],
      loading: false,
      loading1: false,
      iscode: true,
      timer: 60, //验证码倒计时
      disabled: true,
      //非空验证
      rulesFrom: {
        informantPhone: [{required: false, message: "请输入手机号", trigger: "blur"}, {
          validator: checkphone, trigger: "blur"
        }
        ],
        informantIdNumber: [{required: false, message: "请输入证件号", trigger: "blur"},
          {
            validator: isCnNewID, trigger: "blur"
          },],
        informantEmail: [{required: true, message: "请输入邮箱号", trigger: "blur"},],
        reportSubject: [{required: true, message: "请选择举报对象", trigger: "blur"},],
        questionType: [{required: true, message: "请选择问题类型", trigger: "blur"},],
        unreliableName: [{required: true, message: "请输入姓名", trigger: "blur"},],
        unitName: [{required: true, message: "请输入单位名称", trigger: "blur"},],
        unreliableType: [{required: true, message: "请选择违规主体", trigger: "blur"},],
        unreliableActType: [{required: true, message: "请选择违规行为", trigger: "blur"},],
        unreliableUnitName: [{required: true, message: "请输入单位名称", trigger: "blur"},],
        uscc: [{required: true, message: "请输入统一社会信用代码", trigger: "blur"},
          {
            pattern: /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/,
            message: '请输入合法统一社会信用代码',
            trigger: 'blur'
          }],
        reportItem: [
          {required: true, message: "请输入举报内容", trigger: "blur"},
          // {validator: this.validateContent}
        ],
        informantAppeal: [{required: true, message: "请输入个人诉求", trigger: "blur"},],
        // reportFileIds: [{ required: true, message: '请上传凭证', trigger: 'blur' }]
      },
    };
  },
  created () {
    this.formdata.informantDocumentType = '1';
    if (this.$route.query.updateFormdata !== 'undefined' && this.$route.query.updateFormdata != null && this.$route.query.updateFormdata !== '') {
      var reportFileId = [];
      var certificateAttachmentId = [];
      this.formdata = this.$route.query.updateFormdata;
      this.formdata.reportFileIds = reportFileId;
      this.formdata.certificateAttachmentIds = certificateAttachmentId;
      this.formdata.unreliableActType = this.formdata.unreliableActType.split(",")
      if (this.formdata.questionType) {
        this.getType(this.formdata.questionType, 2)
      }
      if(this.formdata.unreliableType){
        this.getType(this.formdata.unreliableType, 3)
      }
      var object = [];
      var certificateObject = [];
      if (this.formdata.reportFiles) {
        this.formdata.reportFiles.forEach(element => {
          var obj = {
            name: '',
            id: ''
          }
          obj.name = element.fileName;
          obj.id = element.id;
          object.push(obj);
          this.formdata.reportFileIds.push(element.id);
        });
      }

      this.formdata.certificateAttachmentFiles.forEach(element => {
        var obj = {
          name: '',
          id: ''
        }
        obj.name = element.fileName;
        obj.id = element.id;
        certificateObject.push(obj);
        this.formdata.certificateAttachmentIds.push(element.id);
      });
      this.reportFileList = object;
      this.certificateFileList = certificateObject;
      this.formdata.reportSubject = 1
      // console.log(this.formdata);
    }
  },
  methods: {
    getSelectedLabels(selectedValues) {
      return selectedValues.map(value => {
        const option = this.unreliableActTypeOptions.find(item => item.typeCode === value);
        return option ? option.typeValue : value;
      });
    },
    removeTag(index) {
      this.formdata.unreliableActType.splice(index, 1);
    },
    // 返回上一级
    back () {
      this.$router.back();
    },
    getType (parentCode, level) {
      if (!parentCode && parentCode !== '0') {
        return
      }
      personService.getType(parentCode).then((res) => {
        if (level === 1) {
          this.questionTypeOptions = res.data;
        }
        if (level === 2) {
          this.unreliableTypeOptions = res.data;
        }
        if (level === 3) {
          this.unreliableActTypeOptions = res.data;
        }
      }).catch(error => {
        this.$message({message: error, type: 'warning'});
      })
    },
    // 问题类型变化
    questionTypeChange () {
      this.formdata.unreliableType =  ''
      this.formdata.unreliableActType =  []
      this.getType(this.formdata.questionType,2)
    },
    // 违规主体变化
    unreliableTypeChange () {
      this.formdata.unreliableActType =  []
      this.formdata.reportSubject = this.unreliableTypeOptions.find(item => item.typeCode === this.formdata.unreliableType).mainType
      this.getType(this.formdata.unreliableType,3)
    },
    subjectChangeForm () {
      // debugger
      this.$refs['formdata'].clearValidate()
      // if (this.formdata.reportSubject === "1") {
      //   this.$refs['formdata'].clearValidate(['unreliableName'])
      //   this.$refs['formdata'].clearValidate(['unitName'])
      // }
      // if (this.formdata.reportSubject === "2") {
      //   this.$refs['formdata'].clearValidate(['unreliableUnitName'])
      //   this.$refs['formdata'].clearValidate(['uscc'])
      // }
    }
    ,
    //手机号1校验
    checkPhone () {
      //定义phone，通过唯一id拿到input框输入的值
      const phone = document.getElementById('informantPhone').value;
      if (!(/^1[34578]\d{9}$/.test(phone))) {  //手机号正则校验
        if (phone === '') { //若手机号为空
          this.s_telephone1 = "请输入手机号码";
          return false;
        } else { //手机号非空的报错信息
          this.s_telephone1 = "手机号码格式错误";
          return false;
        }
      } else { //手机号正确则无错误信息
        this.s_telephone1 = "";
        return true;
      }
    },

    // 暂存
    staging () {
      // 匿名举报默认举报人类型为个人
      this.formdata.informantType = '1'
      if (this.formdata.id !== 'undefined' && this.formdata.id != null && this.formdata.id !== '') {
        this.formdata.isSubmit = 0
        delete this.formdata.certificateFileId
        delete this.formdata.certificateAttachmentFiles
        delete this.formdata.reportFiles
        //1.在低版本中validateField的第一个参数只能接收String类型，这里以String为例
        //将需要进行表单校验的参数放在一个数组中
        var valiSome = ['informantEmail', 'reportSubject']
        //设置布尔值
        var flag = true
        //使用validateField方法来进行多个参数验证
        valiSome.forEach((item, key) => {
          this.$refs.formdata.validateField(item, valid => {
            if (valid.length) {
              this.$message({
                message: '暂存提交请必填“邮箱”跟“举报对象”',
                type: 'warning'
              });
              // this.loading = false
              return flag = false

            }
          })
        })
        if (flag) {
          this.loading1 = true
          // 处理多选框
          let params = JSON.parse(JSON.stringify(this.formdata))
          params.unreliableActType = this.formdata.unreliableActType.join(',')
          personService.updatereport(params).then((res) => {
            this.$msgbox('暂存成功 可以根据工单号'+res.data+'查询修改数据', '提示', {
              confirmButtonText: '确定',
            })
            this.loading1 = false
            this.formdata.workOrderNo = res.data
          }).catch(res => {
            this.loading1 = false
            this.$message({
              message: res.response.data.message,
              type: 'warning'
            });
          })
        }
      } else {
        this.formdata.isSubmit = 0
        //1.在低版本中validateField的第一个参数只能接收String类型，这里以String为例
        //将需要进行表单校验的参数放在一个数组中
        var valiSome = ['informantEmail', 'reportSubject']
        //设置布尔值
        var flag = true
        //使用validateField方法来进行多个参数验证
        valiSome.forEach((item, key) => {
          this.$refs.formdata.validateField(item, valid => {
            if (valid.length) {
              this.$message({
                message: '暂存提交请必填“邮箱”跟“举报对象”',
                type: 'warning'
              });
              return flag = false
            }
          })
        })
        if (flag) {
          this.loading1 = true
          // 处理多选框
          let params = JSON.parse(JSON.stringify(this.formdata))
          params.unreliableActType = this.formdata.unreliableActType.join(',')
          personService.reportsub(params, this.otp).then((res) => {
            this.$msgbox('暂存成功 可以根据工单号'+res.data+'查询修改数据', '提示', {
              confirmButtonText: '确定',
            })
            this.loading1 = false
            this.formdata.workOrderNo = res.data
            this.getOtp()
          }).catch(res => {
            this.loading1 = false
            this.$message({
              message: res.response.data.message,
              type: 'warning'
            });
            this.getOtp()
          })
        }
      }
    },

    // 提交信息
    submit () {
      // 匿名举报默认举报人类型为个人
      this.formdata.informantType = '1'
      if (this.formdata.id !== 'undefined' && this.formdata.id != null && this.formdata.id !== '') {
        delete this.formdata.certificateFileId
        delete this.formdata.certificateAttachmentFiles
        delete this.formdata.reportFiles
        this.$refs.formdata.validate(valid => {
          // 点击确定新增校验哪些值没传
          if (valid) {
            this.formdata.isSubmit = 1
            this.loading = true
            // 处理多选框
            let params = JSON.parse(JSON.stringify(this.formdata))
            params.unreliableActType = this.formdata.unreliableActType.join(',')
            personService.updatereport(params).then((res) => {
              this.$msgbox('提交成功 可以根据工单号'+res.data+'查询数据', '提示', {
                confirmButtonText: '确定',
              })
              this.formdata = {
                informantDocumentType: "1",
                certificateAttachmentIds: [], //举报人证件附件ID
                reportType: 2, //举报类型 1-实名举报 2-匿名举报
                reportFileIds: [], //佐证材料
                reportSubject: "1",
                questionType: '',
                unreliableType: '',
                unreliableActType: []
              }
              this.formdata.reportSubject = this.$route.query.id
              this.reportFileList = []
              this.certificateFileList = []
            }).catch(res => {
              this.loading = false
              this.$message({
                message: res.response.data.message,
                type: 'warning'
              });
            })
            this.loading = false
          }
        });
      } else {
        this.$refs.formdata.validate(valid => {
          // 点击确定新增校验哪些值没传
          if (valid) {
            this.formdata.isSubmit = 1
            this.loading = true
            // 处理多选框
            let params = JSON.parse(JSON.stringify(this.formdata))
            params.unreliableActType = this.formdata.unreliableActType.join(',')
            personService.reportsub(params, this.otp).then((res) => {
              this.$msgbox('提交成功 可以根据工单号'+res.data+'查询数据', '提示', {
                confirmButtonText: '确定',
              })
              this.formdata = {
                informantDocumentType: "1",
                certificateAttachment: "", //举报人证件附件
                certificateAttachmentIds: [], //举报人证件附件ID
                reportType: 2, //举报类型 1-实名举报 2-匿名举报
                reportFileIds: [], //佐证材料
                reportSubject: "1",
                questionType: '',
                unreliableType: '',
                unreliableActType: []
              }
              this.formdata.reportSubject = this.$route.query.id
              this.reportFileList = []
              this.certificateFileList = []
              this.loading = false
              this.getOtp()
            }).catch(res => {
              this.loading = false
              this.$message({
                message: res.response.data.message,
                type: 'warning'
              });
              this.getOtp()
            })
          }
        });
      }
    },
    // 有效证件附件上传文件成功回调
    effectivesuccess (response, file, fileList) {
      if (response.code !== '200') {
        this.$message({message: response.data, type: 'warning'});
        file.status = 'fail'
        return
      }
      this.getOtp()
      this.formdata.certificateAttachmentIds.push(response.data.id);
    },
    // 有效证件附件上传删除回调
    beforeremove (response, file, fileList) {
      if(response && response.response && response.response.data && response.response.data.id) {
        let index = this.formdata.certificateAttachmentIds.indexOf(response.response.data.id);
        if(index > -1) {
          this.formdata.certificateAttachmentIds.splice(index, 1);
        }
      }
    },
    // 佐证材料上传文件成功回调
    evidencesuccess (response, file, fileList) {
      if (response.code !== '200') {
        this.$message({message: response.data, type: 'warning'});
        file.status = 'fail'
        return
      }
      this.getOtp()
      this.formdata.reportFileIds.push(response.data.id);
      console.log(this.formdata.reportFileIds, "佐证材料");
    },
    // 佐证材料上传文件删除回调
    evidenbeforeremove (response, file, fileList) {
      if(response && response.response && response.response.data && response.response.data.id) {
        let index = this.formdata.reportFileIds.indexOf(response.response.data.id);
        if(index > -1) {
          this.formdata.reportFileIds.splice(index, 1);
        }
      }
      console.log(this.formdata.reportFileIds, "佐证材料");
    },
    beforeUploadFile(file) {
      const maxSize = 20 * 1024 * 1024; // 20MB，以字节为单位
      if (file.size > maxSize) {
        this.$message({message:"单个文件大小不能超过20MB，请重新上传。", type: 'warning'});
        return false; // 阻止上传
      }
      return true; // 允许上传
    },
    handleExcel () {
      // console.log("handleExcel");
    },
    onload (file) {
      console.log(file.response.data.id, "文件下载");
    },
    getOtp () {
      personService.getOtp().then((res) => {
        if (res.code === '200') {
          this.otp = res.data
        } else {
          this.$message({message: res.data, type: 'warning'});
        }
      })
    }
  },
  mounted () {
    this.getOtp()
    this.getType('0',1)
    this.formdata.reportSubject = this.$route.query.id
  },
};
</script>

<style lang="scss" scoped>

::v-deep .el-button--small {
  span {
    color: #ffffff !important;

  }

}

::v-deep .el-button--primary {
  span {
    color: #ffffff !important;

  }
}

.anonymous {
  //   padding-bottom: 50px;
  //   padding: 0 300px;
  margin: 0 auto;
  width: 1070px;
  display: flex;
  //   overflow: auto;
  //   height: 100%;
}

// .required:before{
// content:'* ';
// color: red;
// }
.el-button--default {
  // color: #ffffff;
}

::v-deep .el-form-item {
  width: 50%;
}

::v-deep .el-form-item__label {
  width: 160px !important;
}

h3 {
  background-color: #1890ff;
  padding: 10px;
  text-align: center;
  margin: 0px 0 !important;
  color: #FFFFFF;
}

span {
  display: block;
  color: #000000;
  background-color: #FFFBE6;
  padding: 0 30px;
  line-height: 28px;
  border: 1px solid #FFE58F;
  font-size: 12px;
  margin: 20px 0;

  p {
    font-size: 16px;
  }
}

.jc-c .el-button {
  width: 100px;
}

.tips {
  display: flex;
  align-items: center;
  margin: 5px 0;
  justify-content: space-between;

  span {
    border: 0;
    display: flex;
    align-items: center;
    padding: 0;
    font-size: 18px;
    margin: 5px 0;
  }

  img {
    width: 20px;
    margin-right: 10px;
  }

  .back {
    width: 10px;
  }
}

::v-deep .el-form-item__content {
  display: flex;
}

::v-deep .el-select {
  width: 90%;

  .el-input {
    width: 100%;
  }
}

::v-deep .el-input, .el-input.is-disabled .el-input__inner {
  width: 90%;
}

::v-deep .upload {
  display: flex;
}

::v-deep .el-upload-list {
  display: flex;
  align-items: center;
}

::v-deep .el-upload-list__item:first-child {
  margin-top: 0;
}

.must {
  padding: 0;
  margin: 0;
  background-color: #1890ff;
  height: 0;
  display: inline-block;
  border: none;
  color: #F56C6C;
  font-size: 16px;
}

.el-textarea__inner {
  font-size: 16px;
  color: #000;
  height: 32px !important;
  line-height: 32px;
}


::v-deep .el-input__inner {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: #606266 !important;
  //color: #000 ;
  display: inline-block;
  height: 40px;
  line-height: 40px !important;
  //line-height: 32px !important;
  outline: 0;
  padding: 0 15px;
  transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  width: 100%;
}
</style>
